export interface UnreadCounts {
  unreadCount: number
  chatUnreadCount: number
  reportCount: number
}

function toCount(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value) && value > 0 ? value : 0
}

export function extractUnreadCounts(data: unknown): UnreadCounts {
  if (typeof data !== "object" || data === null) {
    return { unreadCount: 0, chatUnreadCount: 0, reportCount: 0 }
  }
  const payload = data as Record<string, unknown>
  const counts =
    typeof payload.counts === "object" && payload.counts !== null
      ? (payload.counts as Record<string, unknown>)
      : {}
  return {
    unreadCount: toCount(counts.unreadCount ?? payload.unreadCount),
    chatUnreadCount: toCount(counts.chatUnreadCount ?? payload.chatUnreadCount),
    reportCount: toCount(counts.reportCount ?? payload.reportCount),
  }
}
